import { PageHero } from "../components/PageHero";
import { ContactSection } from "../components/sections/ContactSection";
import { FAQSection } from "../components/sections/FAQSection";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        overline="Kontakt"
        title="Zacznij"
        emphasis="rozmowę."
        subtitle="Powiedz nam, gdzie chcesz rosnąć. Pokażemy systemy, które Cię tam doprowadzą - bez zobowiązań i żargonu."
      />
      <ContactSection submitLabel="Wyślij wiadomość" />
      <FAQSection />
    </div>
  );
}
